import MessageBanner from 'LuxKit/Banners/MessageBanner'
import TextButton from 'LuxKit/Button/TextButton'
import LinePhoneIcon from 'LuxKit/Icons/line/LinePhoneIcon'
import BodyText from 'LuxKit/Typography/BodyText'
import OfferComparisonModal from 'components/OfferComparison/OfferComparisonModal'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import Group from 'components/utils/Group'
import ModalContext from 'contexts/ModalContext'
import { useAppSelector } from 'hooks/reduxHooks'
import { rem } from 'polished'
import React, { useCallback, useContext, useMemo } from 'react'
import { selectCartActiveComparison } from 'selectors/cartOfferComparisonSelectors'
import styled from 'styled-components'

const StyledMobileContainer = styled(Group)`
  padding: 0 ${rem(16)};
`

function UserCartComparisonBanner() {
  const showModal = useContext(ModalContext)
  const isSpoofed = useAppSelector(state => state.auth.account.isSpoofed)
  const userOfferCartComparison = useAppSelector(selectCartActiveComparison)

  const showUserCartComparisonBanner = useMemo(() => (
    !isSpoofed && userOfferCartComparison && userOfferCartComparison.length > 0
  ), [isSpoofed, userOfferCartComparison])

  const openComparisonModal = useCallback(() => {
    showModal(<OfferComparisonModal mode="user-cart" />)
  }, [showModal])

  if (!showUserCartComparisonBanner) {
    return null
  }

  return (
    <>
      <CSSBreakpoint min="tablet">
        <MessageBanner
          kind="informational-primary"
          icon={<LinePhoneIcon />}
          heading="Your agent has shared a tailored comparison"
          description="Side-by-side comparison to help you decide."
          primaryActionButtonProps={{
            children: 'View comparison',
            onClick: openComparisonModal,
          }}
        />
      </CSSBreakpoint>
      <CSSBreakpoint max="mobile">
        <StyledMobileContainer direction="horizontal" gap={8}>
          <LinePhoneIcon />
          <Group direction="vertical" horizontalAlign="start" gap={8}>
            <Group direction="vertical" gap={4}>
              <BodyText variant="medium" weight="bold">Your agent has shared a tailored comparison</BodyText>
              <BodyText variant="medium">Side-by-side comparison to help you decide.</BodyText>
            </Group>
            <TextButton kind="secondary" onClick={openComparisonModal}>View comparison</TextButton>
          </Group>
        </StyledMobileContainer>
      </CSSBreakpoint>
    </>
  )
}

export default UserCartComparisonBanner
